import { Locale, setDefaultOptions } from "date-fns";
import { pt } from "date-fns/locale";
import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import moment from "moment-timezone";
import "moment/locale/pt";
import { initReactI18next } from "react-i18next";

const lng = window.location.hostname.substring(0, 3) === "en." ? "en" : "pt";
export const dateLocales: Record<string, Locale> = {
  pt,
};
// Update moment and date-fns locale
i18n.on("languageChanged", function (lng: any) {
  moment.locale(lng);
  setDefaultOptions({ locale: dateLocales[lng] });
});

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    ns: ["common"],
    defaultNS: "common",
    lng,
    fallbackLng: "en", // to stop trying to fetch dev transations
    debug: false,
    interpolation: {
      escapeValue: false, // react already safe from xss as escaped by default
    },
    initImmediate: false, // makes the language code accessible in components
  });

export default i18n;
